// extracted by css-extract-rspack-plugin
export default {"size580":"580px","container":"DateRangePicker-module__container___HQwUD"};